import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
var SAMPLE_BUFFER_SIZE = 2048;
var PLAYBACK_MODE = {
  NORMAL: "NORMAL",
  PING_PONG: "PING_PONG",
  REVERSE: "REVERSE"
};
export var RECORD_MODE = {
  USER_MEDIA: "USER_MEDIA",
  STREAM: "STREAM"
};

var Sample =
/*#__PURE__*/
function () {
  function Sample(context) {
    var recordMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RECORD_MODE.USER_MEDIA;
    var rawBuffer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Float32Array(1);

    _classCallCheck(this, Sample);

    this.recordMode = recordMode;
    this._recordStream = null;

    if (this.recordMode === RECORD_MODE.USER_MEDIA) {
      this.recordInput = context.createGain();
    } else {
      this.recordInput = context.createMediaStreamDestination();
    }

    this.context = context;
    this.buffer = this.context.createBuffer(2, rawBuffer.length, this.context.sampleRate);
    this.rawBuffer = rawBuffer.slice();
    this.stream = null;
    this._recordProcessor = null;
    this.overdub = false;
    this.normalize = false;
    this.playbackMode = PLAYBACK_MODE.NORMAL;
    this.copyRawToBuffer(this.rawBuffer);
  }

  _createClass(Sample, [{
    key: "load",
    value: function load(path) {
      var _this = this;

      return fetch(path).then(function (response) {
        return response.arrayBuffer();
      }).then(function (myBlob) {
        return new Promise(function (resolve, reject) {
          _this.context.decodeAudioData(myBlob, resolve, reject);
        });
      }).then(function (buffer) {
        _this.rawBuffer = new Float32Array(_this.buffer.length);
        _this.rawBuffer = buffer.getChannelData(0);

        _this.setBuffer();

        return _this;
      });
    }
  }, {
    key: "reverse",
    value: function reverse() {
      this.playbackMode = PLAYBACK_MODE.REVERSE;
      this.copyRawToBuffer(this.rawBuffer.slice().reverse());
    }
  }, {
    key: "pingpong",
    value: function pingpong() {
      this.playbackMode = PLAYBACK_MODE.PING_PONG;
      var newArray = new Float32Array(this.rawBuffer.length * 2);
      newArray.set(this.rawBuffer, 0);
      newArray.set(this.rawBuffer.slice().reverse(), this.rawBuffer.length - 1);
      this.copyRawToBuffer(newArray);
    }
  }, {
    key: "normal",
    value: function normal() {
      this.playbackMode = PLAYBACK_MODE.NORMAL;
      this.copyRawToBuffer(this.rawBuffer);
    }
  }, {
    key: "record",
    value: function record() {
      var _this2 = this;

      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      switch (this.recordMode) {
        case RECORD_MODE.STREAM:
          this.recordStream(this.recordInput.stream, cb);
          break;

        case RECORD_MODE.USER_MEDIA:
          navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
          }).then(function (stream) {
            return _this2.recordStream(stream, cb);
          });
          break;
      }
    }
  }, {
    key: "recordStream",
    value: function recordStream(stream) {
      var _this3 = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.buffered = 0;
      this.stream = new Float32Array(0);
      this._recordStream = this.context.createMediaStreamSource(stream);
      this._recordProcessor = this.context.createScriptProcessor(SAMPLE_BUFFER_SIZE, 1, 2);

      this._recordStream.connect(this._recordProcessor);

      this._recordProcessor.connect(this.context.destination);

      this._recordProcessor.onaudioprocess = function (e) {
        var chunk = e.inputBuffer.getChannelData(0);
        var newStream = new Float32Array(_this3.stream.length + chunk.length);
        newStream.set(_this3.stream);
        newStream.set(chunk, chunk.length * _this3.buffered);
        _this3.stream = newStream;
        _this3.buffered++;
        cb(_this3.stream.length, _this3.buffered);
      };
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      this._recordStream.disconnect(this._recordProcessor);

      this._recordProcessor.disconnect(this.context.destination);

      this._recordProcessor.onaudioprocess = null;

      this._recordProcessor.disconnect();

      var recordedBuffer = this.ramp(this.stream);

      if (this.overdub) {
        var mixedBuffer = this.mixRawBuffers(recordedBuffer, this.rawBuffer);
        this.rawBuffer = mixedBuffer;
      } else {
        this.rawBuffer = recordedBuffer;
      }

      this.setBuffer();
    }
  }, {
    key: "setBuffer",
    value: function setBuffer() {
      switch (this.playbackMode) {
        case PLAYBACK_MODE.NORMAL:
          this.normal();
          break;

        case PLAYBACK_MODE.PING_PONG:
          this.pingpong();
          break;

        case PLAYBACK_MODE.REVERSE:
          this.reverse();
          break;

        default:
          this.normal();
          break;
      }
    }
  }, {
    key: "copyRawToBuffer",
    value: function copyRawToBuffer(rawBuffer) {
      var copyBuffer = rawBuffer;

      if (this.normalize) {
        copyBuffer = this.normalize(copyBuffer);
      }

      this.buffer = this.context.createBuffer(2, copyBuffer.length, this.context.sampleRate);
      this.buffer.copyToChannel(copyBuffer, 0);
      this.buffer.copyToChannel(copyBuffer, 1);
    }
  }, {
    key: "trim",
    value: function trim(buffer) {
      var startIndex = 0;

      for (var i = 0; i < buffer.length; i++) {
        if (buffer[i] > 0) {
          startIndex = i;
          break;
        }
      }

      return buffer.slice(startIndex);
    }
  }, {
    key: "ramp",
    value: function ramp(buffer) {
      var newBuffer = this.trim(buffer);
      var BUFFER_SIZE = 512;

      if (newBuffer.length > BUFFER_SIZE) {
        for (var i = 0; i < BUFFER_SIZE; i++) {
          newBuffer[i] = newBuffer[i] * i / BUFFER_SIZE;
        }

        var j = BUFFER_SIZE;

        for (var _i = newBuffer.length - BUFFER_SIZE; _i < newBuffer.length; _i++) {
          j--;
          newBuffer[_i] = newBuffer[_i] * j / BUFFER_SIZE;
        }
      }

      return newBuffer;
    }
  }, {
    key: "normalize",
    value: function normalize(buffer) {
      var b = buffer.slice();
      var va = -0.98; // a

      var vb = 0.98; // b

      var vmin = -(1 - 0.98); // A

      var vmax = 1 - 0.98; // B

      b.forEach(function (v) {
        if (v > vmax) {
          vmax = v;
        }

        ;

        if (v < vmin) {
          vmin = v;
        }

        ;
      });
      return b.map(function (v) {
        return va + (v - vmin) * (vb - va) / (vmax - vmin);
      });
    }
  }, {
    key: "mixRawBuffers",
    value: function mixRawBuffers(bufferA, bufferB) {
      var bufferLength = this.getLongestBuffer(bufferA, bufferB);
      var mixedBuffer = new Float32Array(bufferLength);

      for (var i = 0; i < bufferLength; i++) {
        var aValue = 0;
        var bValue = 0;

        if (bufferA[i] != undefined) {
          aValue = bufferA[i];
        }

        if (bufferB[i] != undefined) {
          bValue = bufferB[i];
        }

        mixedBuffer[i] = aValue + bValue;
      }

      return mixedBuffer;
    }
  }, {
    key: "getLongestBuffer",
    value: function getLongestBuffer(bufferA, bufferB) {
      return bufferA.length > bufferB.length ? bufferA.length : bufferB.length;
    }
  }]);

  return Sample;
}();

export { Sample as default };